const qualities = ["original", "thumbnail", "blur"] as const;

export type CoverImageQuality = (typeof qualities)[number];

export const chooseCoverImageQuality = (url: string | undefined, quality: CoverImageQuality): string | undefined =>
  url?.replace(new RegExp(`\\/(?:${qualities.join("|")})\\.jpg$`), `/${quality}.jpg`);

// There is some legacy data from cappelen rather than aja.bs
export const isValidCoverImage = (imageUrl: string | undefined): imageUrl is string => !!imageUrl?.includes("aja.bs");
